import {
  PIM_TAX_DETAIL_FIELD_KEY
} from "./chunk-RS5ET3Q3.js";
import {
  BaseItemModel_default
} from "./chunk-UPAELC5I.js";
import {
  BaseModel_default
} from "./chunk-ITJMNR7M.js";

// src/Pim/PimTax/Model.ts
var TaxModel = class extends BaseModel_default {
  constructor(entities) {
    super(entities);
    if (entities) {
      this.items = entities._embedded.item.map((element) => {
        return new TaxItemModel(element);
      });
    }
  }
};
var TaxItemModel = class extends BaseItemModel_default {
  constructor(entity) {
    super(entity);
    this.id = null;
    this.name = null;
    this.state = null;
    this.country = null;
    this.customer_group = null;
    this.tax_group = null;
    this.rate = null;
    this.published = null;
    this.created_user_name = null;
    this.modified_user_name = null;
    this.created_time = null;
    this.publish_up = null;
    this.modified_time = null;
    this.custom_fields = null;
    this.toJSON = () => {
      return {
        ...this.baseToJSON(),
        [PIM_TAX_DETAIL_FIELD_KEY.ID]: this.id,
        [PIM_TAX_DETAIL_FIELD_KEY.NAME]: this.name,
        [PIM_TAX_DETAIL_FIELD_KEY.STATE]: this.state,
        [PIM_TAX_DETAIL_FIELD_KEY.COUNTRY]: this.country,
        [PIM_TAX_DETAIL_FIELD_KEY.CUSTOMER_GROUP]: this.customer_group,
        [PIM_TAX_DETAIL_FIELD_KEY.TAX_GROUP]: this.tax_group,
        [PIM_TAX_DETAIL_FIELD_KEY.RATE]: this.rate,
        [PIM_TAX_DETAIL_FIELD_KEY.PUBLISHED]: this.published,
        [PIM_TAX_DETAIL_FIELD_KEY.CREATED_USER_NAME]: this.created_user_name,
        [PIM_TAX_DETAIL_FIELD_KEY.MODIFIED_USER_NAME]: this.modified_user_name,
        [PIM_TAX_DETAIL_FIELD_KEY.CREATED_TIME]: this.created_time,
        [PIM_TAX_DETAIL_FIELD_KEY.PUBLISH_UP]: this.publish_up,
        [PIM_TAX_DETAIL_FIELD_KEY.MODIFIED_TIME]: this.modified_time,
        [PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS]: this.custom_fields
      };
    };
    if (entity) {
      this.id = entity[PIM_TAX_DETAIL_FIELD_KEY.ID] ?? "";
      this.name = entity[PIM_TAX_DETAIL_FIELD_KEY.NAME] ?? "";
      this.state = entity[PIM_TAX_DETAIL_FIELD_KEY.STATE] ?? "";
      this.country = entity[PIM_TAX_DETAIL_FIELD_KEY.COUNTRY] ?? "";
      this.customer_group = entity[PIM_TAX_DETAIL_FIELD_KEY.CUSTOMER_GROUP] ?? "";
      this.tax_group = entity[PIM_TAX_DETAIL_FIELD_KEY.TAX_GROUP] ?? "";
      this.rate = entity[PIM_TAX_DETAIL_FIELD_KEY.RATE] ?? "";
      this.published = entity[PIM_TAX_DETAIL_FIELD_KEY.PUBLISHED] ?? "";
      this.created_user_name = entity[PIM_TAX_DETAIL_FIELD_KEY.CREATED_USER_NAME] ?? "";
      this.modified_user_name = entity[PIM_TAX_DETAIL_FIELD_KEY.MODIFIED_USER_NAME] ?? "";
      this.created_time = entity[PIM_TAX_DETAIL_FIELD_KEY.CREATED_TIME] ?? "";
      this.publish_up = entity[PIM_TAX_DETAIL_FIELD_KEY.PUBLISH_UP] ?? "";
      this.modified_time = entity[PIM_TAX_DETAIL_FIELD_KEY.MODIFIED_TIME] ?? "";
      this.custom_fields = entity[PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS] ?? "";
    }
  }
};
TaxItemModel.__transformItemToApiOfCreation = (data) => {
  let formData = new FormData();
  const excluded = [PIM_TAX_DETAIL_FIELD_KEY.ID, PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS];
  Object.keys(PIM_TAX_DETAIL_FIELD_KEY).forEach((index) => {
    if (!excluded.includes(PIM_TAX_DETAIL_FIELD_KEY[index]) && data[PIM_TAX_DETAIL_FIELD_KEY[index]]) {
      formData.append(PIM_TAX_DETAIL_FIELD_KEY[index], data[PIM_TAX_DETAIL_FIELD_KEY[index]]);
    }
  });
  if (data[PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS] && Object.keys(data[PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS]).length) {
    Object.keys(data[PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS]).forEach(function(key) {
      formData.append(
        [PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS] + "[" + key + "]",
        data[PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS][key]
      );
    });
  }
  return formData;
};
TaxItemModel.__transformItemToApiOfUpdation = (data) => {
  let formData = {};
  const excluded = [PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS];
  Object.keys(PIM_TAX_DETAIL_FIELD_KEY).forEach((index) => {
    if (!excluded.includes(PIM_TAX_DETAIL_FIELD_KEY[index]) && data[PIM_TAX_DETAIL_FIELD_KEY[index]]) {
      formData[PIM_TAX_DETAIL_FIELD_KEY[index]] = data[PIM_TAX_DETAIL_FIELD_KEY[index]];
    }
  });
  if (data[PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS] && Object.keys(data[PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS]).length) {
    formData[PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS] = {};
    Object.keys(data[PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS]).forEach(function(key) {
      formData[PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS][key] = data[PIM_TAX_DETAIL_FIELD_KEY.CUSTOM_FIELDS][key];
    });
  }
  return formData;
};

export {
  TaxModel,
  TaxItemModel
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
